module.exports = __webpack_public_path__ + "static/img/bottom_sheet_up_foot_download.ce90b22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/smart/bottom_sheet_up_foot_download.png
// module id = mU+/
// module chunks = 1